(function () {
  function initAccess() {
    var root = document.getElementById('barbas-access');
    var signup = document.getElementById('barbas-access-signup');
    if (!root || !signup) return;
    var introEnabled = root.dataset.introEnabled === 'true';
    document.body.classList.toggle('BarbasAccess--directEntry', !introEnabled);

    var systemPanel = document.createElement('div');
    systemPanel.className = 'BarbasAccess__panel BarbasAccess__panel--system';
    systemPanel.dataset.panel = 'system';
    systemPanel.hidden = true;
    systemPanel.innerHTML = '<p class="BarbasAccess__eyebrow">BARBAS / ACCESS</p><p class="BarbasAccess__systemText" aria-live="off"></p><div class="BarbasAccess__storyActions"><button type="button" class="BarbasAccess__storyContinue" data-access-action="continue-story" disabled>CONTINUE</button><button type="button" class="BarbasAccess__storySkip" data-access-action="skip-story">SKIP STORY</button></div>';
    root.insertBefore(systemPanel, root.querySelector('[data-panel="choice"]'));
    var panels = root.querySelectorAll('[data-panel]');
    var frames = Array.prototype.slice.call(root.querySelectorAll('.BarbasAccess__frame'));
    var video = root.querySelector('.BarbasAccess__video');
    var muteButton = root.querySelector('[data-access-action="mute"]');
    var languageButton = root.querySelector('[data-access-action="language-menu"]');
    var chromeStage = root.querySelector('.BarbasAccess__chromeStage');
    var scene = root.querySelector('.BarbasAccess__scene');
    var finalPanel = root.querySelector('[data-panel="final"]');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var timers = [];
    var audioContext;
    var typingBuffer;
    var audioUnlocked = false;
    var muted = window.BarbasAmbient ? window.BarbasAmbient.isMuted() : false;
    var selectedLanguage = 'en';
    var typingNodes = [];
    var languageTitle = Array.prototype.slice.call(root.querySelectorAll('.BarbasAccess__languageTitle span'));
    languageTitle.forEach(function (node) { node.dataset.typeFull = node.textContent; });
    var spanish = {
      choiceEyebrow: 'EL PRÓXIMO LANZAMIENTO EMPIEZA AQUÍ',
      questionOne: '¿QUIERES', questionTwo: 'TENER', questionThree: 'ACCESO?',
      yes: 'SÍ', no: 'NO', choiceHint: 'ELIGE TU CAMINO',
      noEyebrow: 'LA PUERTA SIGUE ABIERTA', noTitle: '¿AÚN NO<br>ESTÁS LISTO?',
      changeMind: 'CAMBIÉ DE OPINIÓN', archiveLabel: 'BARBAS / EL ARCHIVO',
      skipIntro: 'SALTAR INTRO', finalLead: 'YA VISTE DE DÓNDE VENIMOS.',
      finalTitle: 'SÉ EL PRIMERO EN VER<br>LO QUE VIENE.',
      getEarlyAccess: 'OBTÉN ACCESO ANTICIPADO', goSignup: 'IR AL REGISTRO',
      signupHeading: 'REGÍSTRATE AHORA', signupIntro: 'SÉ EL PRIMERO EN VER LO QUE VIENE.',
      phoneNumber: 'Número de teléfono', countryCode: 'Código de país', getAccess: 'OBTÉN ACCESO ANTICIPADO',
      smsConsent: 'Acepto recibir mensajes de texto promocionales de BARBAS en el número indicado.',
      whatsappConsent: 'También acepto recibir mensajes promocionales de BARBAS por WhatsApp en el número indicado. Esta opción es voluntaria e independiente del consentimiento para SMS.',
      smsLegal: '*Al proporcionar tu número de teléfono, aceptas recibir mensajes de texto promocionales automatizados y recurrentes (por ejemplo, recordatorios de carrito) de esta tienda y de terceros que actúen en su nombre. Tu consentimiento no es una condición para comprar productos o servicios. Pueden aplicarse tarifas por mensajes y datos. La frecuencia de los mensajes varía. Responde HELP para obtener ayuda y STOP para cancelar. También aceptas los <a href="https://terms.pscr.pt/legal/shop/dream-print-company/terms_of_service">Términos de servicio</a> y la <a href="https://terms.pscr.pt/legal/shop/dream-print-company/privacy_policy">Política de privacidad</a>.',
      signupConfirmed: 'REGISTRO ENVIADO.',
      signupError: 'No pudimos enviar tu registro. Inténtalo de nuevo.',
      loading: 'CARGANDO...',
      confirmationDetail: 'Tu número fue enviado para recibir novedades de acceso anticipado de BARBAS. Prepárate para descubrir lo que viene.',
      storePassword: 'Ingresa con contraseña', passwordPlaceholder: 'Contraseña', enterStore: 'Ingresar',
      adminPrompt: '¿Eres el propietario de la tienda?', adminLogin: 'Inicia sesión aquí',
      closeSupport: 'Cerrar formulario de ayuda', needHelp: '¿Necesitas ayuda?',
      supportIntro: 'Contáctanos con el siguiente formulario y te responderemos lo antes posible.',
      contactUs: 'Contáctanos', supportSuccess: 'Gracias por escribirnos. Nuestro equipo te responderá pronto.',
      fullName: 'Nombre completo', email: 'Correo electrónico', contactReason: 'Motivo de contacto',
      selectReason: 'Selecciona un motivo', incompleteOrder: 'Pedido incompleto (faltan artículos)',
      wrongItem: 'Recibí el artículo equivocado', orderNotReceived: 'No recibí mi pedido',
      defectiveProduct: 'Producto defectuoso', other: 'Otro', message: 'Mensaje',
      howHelp: '¿Cómo podemos ayudarte?', orderNumber: 'Número de pedido', optional: '(opcional)',
      orderExample: 'Pedido n.º 1234', sendMessage: 'Enviar mensaje'
    };
    var englishOverrides = { storePassword: 'Enter using password', passwordPlaceholder: 'Password', enterStore: 'Enter', adminPrompt: 'Are you the store owner?', adminLogin: 'Log in here' };
    var translations = Array.prototype.slice.call(document.querySelectorAll('[data-i18n], [data-i18n-html], [data-i18n-placeholder], [data-i18n-aria]'));
    translations.forEach(function (node) {
      node.dataset.originalCopy = node.hasAttribute('data-i18n-html') ? node.innerHTML : node.hasAttribute('data-i18n-placeholder') ? node.placeholder : node.hasAttribute('data-i18n-aria') ? node.getAttribute('aria-label') : node.textContent;
    });

    function applyLanguage(language) {
      selectedLanguage = language;
      root.lang = language;
      signup.lang = language;
      document.documentElement.lang = language;
      translations.forEach(function (node) {
        var key = node.dataset.i18n || node.dataset.i18nHtml || node.dataset.i18nPlaceholder || node.dataset.i18nAria;
        var copy = language === 'es' ? spanish[key] : (englishOverrides[key] || node.dataset.originalCopy);
        if (copy == null) return;
        if (node.hasAttribute('data-i18n-html')) node.innerHTML = copy;
        else if (node.hasAttribute('data-i18n-placeholder')) {
          node.placeholder = copy;
          if (node.hasAttribute('aria-label')) node.setAttribute('aria-label', copy);
        }
        else if (node.hasAttribute('data-i18n-aria')) node.setAttribute('aria-label', copy);
        else node.textContent = copy;
        if (node.matches('[data-i18n="questionOne"], [data-i18n="questionTwo"], [data-i18n="questionThree"], [data-i18n-html="noTitle"], [data-i18n="finalLead"], [data-i18n-html="finalTitle"], [data-i18n-html="signupIntro"], [data-i18n="signupConfirmed"], [data-i18n="confirmationDetail"]')) node.dataset.typeFull = node.querySelector('br') ? node.innerHTML.replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]+>/g, '') : node.textContent;
      });
      if (chromeStage) chromeStage.setAttribute('aria-label', language === 'es' ? 'Logotipo cromado giratorio de BARBAS' : 'BARBAS rotating chrome logo');
      if (languageButton) {
        languageButton.textContent = language === 'es' ? 'ESPAÑOL' : 'ENGLISH';
        languageButton.setAttribute('aria-label', language === 'es' ? 'Cambiar idioma' : 'Change language');
      }
      muteButton.textContent = muted ? (language === 'es' ? 'SONIDO DESACTIVADO' : 'SOUND OFF') : (language === 'es' ? 'SONIDO ACTIVADO' : 'SOUND ON');
    }

    signup.hidden = true;
    root.hidden = false;
    document.body.classList.add('BarbasAccess--locked');

    function later(callback, delay) {
      timers.push(window.setTimeout(callback, delay));
    }

    function typeNode(node, speed, done) {
      if (!node) { if (done) done(); return; }
      var copy = node.dataset.typeFull || node.innerText || node.textContent;
      if (reducedMotion.matches) { node.textContent = copy; if (done) done(); return; }
      var characters = Array.from(copy);
      var position = 0;
      node.textContent = '';
      node.classList.add('BarbasAccess__typing');
      if (typingNodes.indexOf(node) === -1) typingNodes.push(node);
      function next() {
        var character = characters[position++];
        node.textContent += character;
        if (character.trim() && position % 2 === 0) typingSound();
        if (position < characters.length) later(next, speed);
        else {
          node.classList.remove('BarbasAccess__typing');
          typingNodes = typingNodes.filter(function (item) { return item !== node; });
          if (done) done();
        }
      }
      if (characters.length) next();
      else if (done) done();
    }

    function typeSequence(nodes, speed, done) {
      nodes.forEach(function (node) {
        node.textContent = '';
        if (typingNodes.indexOf(node) === -1) typingNodes.push(node);
      });
      var index = 0;
      function next() {
        if (index >= nodes.length) { if (done) done(); return; }
        typeNode(nodes[index++], speed, function () { later(next, 90); });
      }
      next();
    }

    function clearSequence() {
      timers.forEach(window.clearTimeout);
      timers = [];
      typingNodes.forEach(function (node) {
        node.textContent = node.dataset.typeFull || node.textContent;
        node.classList.remove('BarbasAccess__typing');
      });
      typingNodes = [];
      frames.forEach(function (frame) { frame.classList.remove('is-active'); });
      root.classList.remove('is-flashing');
      root.classList.remove('is-entering');
      root.classList.remove('is-arriving');
      root.classList.remove('is-question-typing');
      root.classList.remove('is-story-fading');
      if (video) { video.pause(); video.currentTime = 0; }
    }

    function audio() {
      if (!audioUnlocked || muted || reducedMotion.matches) return null;
      try {
        audioContext = audioContext || new (window.AudioContext || window.webkitAudioContext)();
        if (audioContext.state === 'suspended') audioContext.resume();
        return audioContext;
      } catch (error) { return null; }
    }

    function hit(frequency) {
      var context = audio();
      if (!context) return;
      var oscillator = context.createOscillator();
      var gain = context.createGain();
      oscillator.type = 'triangle';
      oscillator.frequency.setValueAtTime(frequency, context.currentTime);
      oscillator.frequency.exponentialRampToValueAtTime(45, context.currentTime + .22);
      gain.gain.setValueAtTime(.045, context.currentTime);
      gain.gain.exponentialRampToValueAtTime(.001, context.currentTime + .25);
      oscillator.connect(gain).connect(context.destination);
      oscillator.start();
      oscillator.stop(context.currentTime + .26);
    }

    function shortTone(frequency, duration, volume) {
      var context = audio();
      if (!context || context.state !== 'running') return;
      var oscillator = context.createOscillator();
      var gain = context.createGain();
      oscillator.type = 'triangle';
      oscillator.frequency.setValueAtTime(frequency, context.currentTime);
      oscillator.frequency.exponentialRampToValueAtTime(frequency * .72, context.currentTime + duration);
      gain.gain.setValueAtTime(volume, context.currentTime);
      gain.gain.exponentialRampToValueAtTime(.001, context.currentTime + duration);
      oscillator.connect(gain).connect(context.destination);
      oscillator.start();
      oscillator.stop(context.currentTime + duration);
    }

    function typingSound() {
      var context = audio();
      if (!context || context.state !== 'running') return;
      if (!typingBuffer) {
        typingBuffer = context.createBuffer(1, Math.floor(context.sampleRate * .022), context.sampleRate);
        var samples = typingBuffer.getChannelData(0);
        for (var index = 0; index < samples.length; index++) {
          samples[index] = (Math.random() * 2 - 1) * (1 - index / samples.length);
        }
      }
      var source = context.createBufferSource();
      var filter = context.createBiquadFilter();
      var gain = context.createGain();
      source.buffer = typingBuffer;
      filter.type = 'highpass';
      filter.frequency.value = 1100 + Math.random() * 500;
      gain.gain.value = .009;
      source.connect(filter).connect(gain).connect(context.destination);
      source.start();
    }
    function hoverSound() {
      if (audioContext && audioContext.state === 'running') shortTone(600, .055, .016);
    }
    function buttonSound() { shortTone(300, .11, .04); }

    function whoosh(reverse) {
      var context = audio();
      if (!context) return;
      var length = Math.floor(context.sampleRate * .85);
      var buffer = context.createBuffer(1, length, context.sampleRate);
      var samples = buffer.getChannelData(0);
      for (var index = 0; index < length; index++) samples[index] = Math.random() * 2 - 1;
      var noise = context.createBufferSource();
      var filter = context.createBiquadFilter();
      var gain = context.createGain();
      noise.buffer = buffer;
      filter.type = 'bandpass';
      filter.frequency.setValueAtTime(reverse ? 3200 : 180, context.currentTime);
      filter.frequency.exponentialRampToValueAtTime(reverse ? 180 : 3200, context.currentTime + .55);
      filter.frequency.exponentialRampToValueAtTime(260, context.currentTime + .85);
      filter.Q.value = .7;
      gain.gain.setValueAtTime(.001, context.currentTime);
      gain.gain.linearRampToValueAtTime(.105, context.currentTime + .42);
      gain.gain.exponentialRampToValueAtTime(.001, context.currentTime + .85);
      noise.connect(filter).connect(gain).connect(context.destination);
      noise.start();
      noise.stop(context.currentTime + .86);
    }

    function lockFinalCopyLayout() {
      finalPanel.querySelectorAll('[data-i18n="finalLead"], [data-i18n-html="finalTitle"]').forEach(function (node) {
        if (node.dataset.layoutLocked) return;
        var rect = node.getBoundingClientRect();
        node.style.width = Math.ceil(rect.width) + 'px';
        node.style.height = Math.ceil(rect.height) + 'px';
        node.dataset.layoutLocked = 'true';
      });
    }

    function stage(name) {
      root.dataset.stage = name;
      panels.forEach(function (panel) { panel.hidden = panel.dataset.panel !== name; });
      if (name === 'final') {
        lockFinalCopyLayout();
      }
      if (chromeStage && scene && finalPanel) {
        var destination = name === 'final' ? finalPanel : scene;
        if (chromeStage.parentNode !== destination) {
          destination.insertBefore(chromeStage, destination.firstChild);
          chromeStage.dispatchEvent(new Event('barbas:stage-resized'));
        }
        if (name === 'final' && root.classList.contains('is-arriving')) {
          var scale = Math.min(14, Math.max(8, Math.max(window.innerWidth, window.innerHeight) / (chromeStage.clientWidth || 220) * 1.8));
          chromeStage.style.setProperty('--barbas-arrival-scale', scale);
        }
      }
      if (introEnabled && name === 'language') typeSequence(languageTitle, 62);
      if (introEnabled && name === 'choice') {
        root.classList.add('is-question-typing');
        typeSequence(Array.prototype.slice.call(root.querySelectorAll('.BarbasAccess__question span')), 54, function () { root.classList.remove('is-question-typing'); });
      }
      if (introEnabled && name === 'no') typeNode(root.querySelector('[data-i18n-html="noTitle"]'), 40);
      if (name === 'final' && !root.classList.contains('is-arriving')) typeSequence(Array.prototype.slice.call(root.querySelectorAll('[data-i18n="finalLead"], [data-i18n-html="finalTitle"]')), 38);
      var focusTarget = root.querySelector('[data-panel="' + name + '"] button');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }

    function finishStory() {
      if (root.dataset.stage !== 'system' || root.classList.contains('is-story-fading')) return;
      if (reducedMotion.matches) { stage('choice'); return; }
      stage('choice');
      systemPanel.hidden = false;
      root.classList.add('is-story-fading');
      later(function () {
        systemPanel.hidden = true;
        root.classList.remove('is-story-fading');
      }, 680);
    }

    function showStory() {
      stage('system');
      var story = selectedLanguage === 'es' ? [
        'IDIOMA ELEGIDO: ESPAÑOL',
        'BARBAS COMENZÓ CON UNAS POCAS GORRAS Y UNA IDEA SENCILLA: CREAR ALGO QUE VALIERA LA PENA ESPERAR.',
        'LOS LANZAMIENTOS SON LIMITADOS.',
        'LA HISTORIA SIGUE CRECIENDO.',
        'EN EL CAMINO SE SUMARON ARTISTAS, INFLUENCERS Y CREADORES.',
        'TAMBIÉN CADA PERSONA QUE USÓ UNA GORRA, COMPARTIÓ UN LANZAMIENTO O VOLVIÓ POR EL SIGUIENTE.',
        'LO QUE EMPEZÓ COMO LA VENTA DE UNAS POCAS GORRAS SE CONVIRTIÓ EN UN MOVIMIENTO IMPULSADO POR QUIENES SIEMPRE ESTÁN AHÍ.',
        'SIN USTEDES, NO EXISTIRÍA BARBAS.',
        'EL SIGUIENTE CAPÍTULO TE ESPERA.'
      ] : [
        'LANGUAGE CHOSEN: ENGLISH',
        'BARBAS BEGAN WITH A FEW HATS AND A SIMPLE IDEA: MAKE SOMETHING WORTH WAITING FOR.',
        'THE DROPS STAY LIMITED.',
        'THE STORY KEEPS GROWING.',
        'ALONG THE WAY, ARTISTS, INFLUENCERS, AND CREATORS BECAME PART OF IT.',
        'SO DID EVERY PERSON WHO WORE A HAT, SHARED A DROP, OR CAME BACK FOR THE NEXT ONE.',
        'WHAT STARTED AS SELLING A FEW HATS BECAME A MOVEMENT CARRIED BY THE PEOPLE WHO SHOW UP.',
        'WITHOUT YOU, THERE IS NO BARBAS.',
        'THE NEXT CHAPTER IS YOURS TO ENTER.'
      ];
      var systemText = systemPanel.querySelector('.BarbasAccess__systemText');
      var continueButton = systemPanel.querySelector('.BarbasAccess__storyContinue');
      systemText.dataset.typeFull = story.join('\n\n');
      systemText.setAttribute('aria-label', story.join(' '));
      continueButton.textContent = selectedLanguage === 'es' ? 'CONTINUAR' : 'CONTINUE';
      systemPanel.querySelector('.BarbasAccess__storySkip').textContent = selectedLanguage === 'es' ? 'SALTAR HISTORIA' : 'SKIP STORY';
      continueButton.disabled = true;
      typeNode(systemText, 18, function () { continueButton.disabled = false; });
    }

    function finalStage() {
      clearSequence();
      root.classList.add('is-flashing');
      later(function () {
        if (!reducedMotion.matches) root.classList.add('is-arriving');
        stage('final');
        if (!reducedMotion.matches) whoosh(true);
      }, 160);
      later(function () { root.classList.remove('is-flashing'); }, 390);
      later(function () {
        if (root.classList.contains('is-arriving')) {
          root.classList.remove('is-arriving');
          stage('final');
        }
      }, 1190);
      hit(112);
    }

    function enter() {
      clearSequence();
      hit(160);
      if (!frames.length || reducedMotion.matches) {
        if (reducedMotion.matches) { finalStage(); return; }
        if (!video) { finalStage(); return; }
      }
      root.classList.add('is-entering');
      whoosh();
      later(function () { hit(85); root.classList.add('is-flashing'); }, 900);
      later(function () {
        stage('montage');
        root.classList.remove('is-entering');
        if (video) {
          video.muted = muted;
          video.currentTime = 0;
          var playback = video.play();
          if (playback && playback.catch) playback.catch(function () { finalStage(); });
        } else {
          var interval = 6000 / frames.length;
          frames.forEach(function (frame, index) {
            later(function () {
              frames.forEach(function (item) { item.classList.remove('is-active'); });
              frame.classList.add('is-active');
              hit(180 + index * 30);
            }, index * interval);
          });
          later(finalStage, frames.length * interval);
        }
      }, 1030);
      later(function () { root.classList.remove('is-flashing'); }, 1240);
    }

    function showSignup() {
      clearSequence();
      root.hidden = true;
      signup.hidden = false;
      document.dispatchEvent(new Event('barbas:signup-opened'));
      document.body.classList.remove('BarbasAccess--locked');
      if (introEnabled) typeNode(signup.querySelector('[data-i18n-html="signupIntro"]'), 27);
      window.scrollTo(0, 0);
      var phone = signup.querySelector('#ps__phone-subscribe');
      if (phone) phone.focus({ preventScroll: true });
    }

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-access-action]');
      if (!button) return;
      var action = button.dataset.accessAction;
      if (!introEnabled && action !== 'mute') {
        audioUnlocked = true;
        if (window.BarbasAmbient) window.BarbasAmbient.start();
        buttonSound();
        if (action === 'yes' || action === 'signup') showSignup();
        if (action === 'no') stage('no');
        if (action === 'back') stage('choice');
        if (action === 'language-menu') applyLanguage(selectedLanguage === 'en' ? 'es' : 'en');
        return;
      }
      if (button.classList.contains('is-pressed')) return;
      audioUnlocked = true;
      if (window.BarbasAmbient) window.BarbasAmbient.start();
      buttonSound();
      button.classList.add('is-pressed');
      window.setTimeout(function () { button.classList.remove('is-pressed'); }, 220);
      if (action === 'language') {
        window.setTimeout(function () {
          clearSequence();
          applyLanguage(button.dataset.language === 'es' ? 'es' : 'en');
          showStory();
        }, 150);
      }
      if (action === 'continue-story' && !button.disabled) window.setTimeout(finishStory, 150);
      if (action === 'skip-story') window.setTimeout(function () { clearSequence(); finishStory(); }, 150);
      if (action === 'language-menu') { clearSequence(); stage('language'); }
      if (action === 'yes') window.setTimeout(enter, 150);
      if (action === 'no') window.setTimeout(function () { clearSequence(); stage('no'); }, 150);
      if (action === 'back') window.setTimeout(function () { stage('choice'); }, 150);
      if (action === 'skip') finalStage();
      if (action === 'signup') window.setTimeout(showSignup, 150);
      if (action === 'mute') {
        muted = !muted;
        if (video) video.muted = muted;
        if (window.BarbasAmbient) window.BarbasAmbient.setMuted(muted);
        muteButton.textContent = muted ? (selectedLanguage === 'es' ? 'SONIDO DESACTIVADO' : 'SOUND OFF') : (selectedLanguage === 'es' ? 'SONIDO ACTIVADO' : 'SOUND ON');
        muteButton.setAttribute('aria-pressed', String(!muted));
        muteButton.setAttribute('aria-label', muted ? 'Turn sound on' : 'Mute sound');
      }
    });

    root.addEventListener('pointerover', function (event) {
      var button = event.target.closest('button');
      if (introEnabled && button && !button.disabled && !button.contains(event.relatedTarget)) hoverSound();
    });

    signup.addEventListener('pointerover', function (event) {
      var button = event.target.closest('button');
      if (introEnabled && button && !button.disabled && !button.contains(event.relatedTarget)) hoverSound();
    });
    signup.addEventListener('keydown', function (event) {
      if (!introEnabled) return;
      if (event.target.id !== 'ps__phone-subscribe') return;
      if (event.key.length === 1 || event.key === 'Backspace') {
        audioUnlocked = true;
        typingSound();
      }
    });
    signup.addEventListener('click', function (event) {
      var button = event.target.closest('button');
      if (!button) return;
      buttonSound();
      button.classList.add('is-pressed');
      window.setTimeout(function () { button.classList.remove('is-pressed'); }, 220);
    });

    if (video) {
      video.addEventListener('ended', finalStage);
      video.addEventListener('error', finalStage);
    }

    document.addEventListener('barbas:signup-submitted', function () {
      var processing = signup.querySelector('[data-signup-processing]');
      var success = signup.querySelector('#ps__sent-message, #preview-success');
      if (!processing || !success || !processing.hidden) return;
      var bar = processing.querySelector('[role="progressbar"]');
      var percent = processing.querySelector('[data-signup-percent]');
      processing.hidden = false;
      document.body.classList.add('BarbasAccess--locked');
      processing.style.setProperty('--barbas-progress', '0%');
      if (percent) percent.textContent = '0%';
      if (bar) bar.setAttribute('aria-valuenow', '0');
      var startedAt;
      function updateProgress(now) {
        if (startedAt == null) startedAt = now;
        var value = Math.min(100, Math.round((now - startedAt) / 2900 * 100));
        processing.style.setProperty('--barbas-progress', value + '%');
        if (percent) percent.textContent = value + '%';
        if (bar) bar.setAttribute('aria-valuenow', String(value));
        if (value < 100) {
          window.requestAnimationFrame(updateProgress);
          return;
        }
        window.setTimeout(function () {
          processing.hidden = true;
          processing.setAttribute('aria-busy', 'false');
          success.hidden = false;
          document.dispatchEvent(new Event('barbas:signup-sent'));
        }, 180);
      }
      window.requestAnimationFrame(updateProgress);
    });

    document.addEventListener('barbas:signup-sent', function () {
      if (!introEnabled) return;
      typeSequence(Array.prototype.slice.call(signup.querySelectorAll('[data-i18n="signupConfirmed"], [data-i18n="confirmationDetail"]')), 25);
    });

    if (reducedMotion.matches) root.classList.add('BarbasAccess--reducedMotion');
    var entryParams = new URLSearchParams(window.location.search);
    var entryLanguage = entryParams.get('lang');
    if (entryLanguage === 'en' || entryLanguage === 'es') applyLanguage(entryLanguage);
    if (entryParams.get('signup') === '1') {
      if (entryParams.get('market') === 'mx' || window.location.hostname.endsWith('.mx')) {
        var entryCountry = signup.querySelector('#ps__country-code');
        if (entryCountry) entryCountry.value = '+52';
      }
      showSignup();
    } else {
      stage(introEnabled ? 'language' : 'choice');
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAccess);
  else initAccess();
  document.addEventListener('shopify:section:load', initAccess);
}());
